"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CRYPTO_COIN_TICKERS = void 0;
const ticker_1 = require("./ticker");
exports.CRYPTO_COIN_TICKERS = [
    ticker_1.Ticker.BNB,
    ticker_1.Ticker.ETH,
    ticker_1.Ticker.BTC,
    ticker_1.Ticker.TRX,
    ticker_1.Ticker.MATIC
];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY3J5cHRvLWNvaW4uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvdGlja2Vycy9jcnlwdG8tY29pbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFQSxxQ0FBaUM7QUFFcEIsUUFBQSxtQkFBbUIsR0FBRztJQUNqQyxlQUFNLENBQUMsR0FBRztJQUNWLGVBQU0sQ0FBQyxHQUFHO0lBQ1YsZUFBTSxDQUFDLEdBQUc7SUFDVixlQUFNLENBQUMsR0FBRztJQUNWLGVBQU0sQ0FBQyxLQUFLO0NBQ0osQ0FBQSJ9